import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import DataTableElement from "../../../components/elements/DataTableElement";
import { iaElementsResource, loadsAISave } from "../../../helpers/configRoutes/backend_helper";
import { Columns } from "./Columns";
import { reset_service } from "../../../store/serviceOrders/action";

const LoadsPre = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [selectedRows, setSelectedRows] = useState([]);
    const [load, setLoad] = useState({ show: false, textLoad: 'Loading AI loads...' });
    const [item, setItem] = useState({});
    const [data, setData] = useState([]);

    useEffect(() => {
        dispatch(reset_service());
    }, [dispatch]);

    useEffect(() => {
        const getData = async () => {
            setLoad({ show: true, textLoad: 'Loading AI loads...' });
            const response = await iaElementsResource('show', {}, id);
            setData(response?.element?.ia_response || []);
            setItem(response?.element || {});
            setLoad({ show: false, textLoad: 'Loading AI loads...' });
        };

        getData();
    }, [id]);

    const openModalAdd = (row = {}) => {
        const stops = (row.stops || []).map((stop, index) => ({
            ...stop,
            id: Number.isInteger(Number(stop.id)) ? Number(stop.id) : '',
            order: stop.order || index + 1,
            status: stop.status || {
                id: stop.status_id || (index === 0 ? 23 : 24),
                name: stop.name || (index === 0 ? 'Pickup' : 'Delivery'),
            },
        }));

        navigate('/loads-new', {
            state: {
                prefillLoad: {
                    ...row,
                    id: null,
                    ai_draft_id: row.id || null,
                    stops,
                    evidences: row.evidences || [],
                    payments: row.payments || [],
                    current_mileage_truck: row.current_mileage_truck || '',
                    current_mileage_trailer: row.current_mileage_trailer || '',
                },
                aiDraftContext: {
                    draftId: row.id || null,
                    sourceElementId: item.id || id,
                    sourceDocumentName: item.ai_usage?.source_document?.original_name || '',
                    returnPath: `/ia-loads/${item.id || id}`,
                },
            },
        });
    };

    const handleGuardar = async () => {
        const response = await loadsAISave({ selectedRows, element: item });
        if (response?.status) {
            navigate('/ai-operations');
        }
    };

    const summary = useMemo(() => {
        const total = data.length;
        const selected = selectedRows.length;
        const matchedEquipment = data.filter((row) => row.truck_id || row.trailer_id).length;
        const completeStops = data.filter((row) => (row.stops || []).length >= 2).length;

        return [
            { label: 'Draft loads', value: total },
            { label: 'Selected to create', value: selected },
            { label: 'Matched equipment', value: matchedEquipment },
            { label: 'With pickup + delivery', value: completeStops },
        ];
    }, [data, selectedRows]);

    const cols = Columns(selectedRows, setSelectedRows, openModalAdd, item);

    return (
        <div className="space-y-6 p-8">
            <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
                <div>
                    <h1 className="text-2xl font-semibold text-slate-800">AI Load Drafts</h1>
                    <p className="text-sm text-slate-500">
                        Review the information extracted from the uploaded document before creating real loads.
                    </p>
                </div>

                {selectedRows.length > 0 && item.status?.id !== 41 && (
                    <button
                        onClick={handleGuardar}
                        className="inline-flex items-center justify-center rounded-xl bg-blue-600 px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-blue-700"
                    >
                        Create selected loads ({selectedRows.length})
                    </button>
                )}
            </div>

            <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-4">
                {summary.map((card) => (
                    <div key={card.label} className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
                        <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">{card.label}</p>
                        <p className="mt-2 text-2xl font-bold text-slate-800">{card.value}</p>
                    </div>
                ))}
            </div>

            <div className="rounded-2xl border border-slate-200 bg-white shadow-sm">
                <div className="border-b border-slate-100 px-5 py-4 text-sm text-slate-500">
                    Source file: <span className="font-semibold text-slate-700">{item.ai_usage?.source_document?.original_name || 'Unknown file'}</span>
                    {item.ai_usage?.total_tokens ? (
                        <span className="ml-3 text-xs text-slate-400">
                            Tokens: {item.ai_usage.total_tokens}
                        </span>
                    ) : null}
                </div>
                <DataTableElement columns={cols} items={data} tableLoad={load} />
            </div>
        </div>
    );
};

export default LoadsPre;
